import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import CustomNavbar from './CustomNavbar';
import './css/Dashboard.css';
import HaesManagement from './srvHaes';


const Service = () => {
    const [firstName, setFirstName] = useState('');
    const [message, setMessage] = useState(null);
    const location = useLocation();

    useEffect(() => {
        // Werte aus localStorage abrufen
        const storedFirstName = localStorage.getItem('firstName');
        setFirstName(storedFirstName || '');

        // Message aus location.state übernehmen
        if (location.state?.message) {
            setMessage(location.state.message);

            // Optional: Nachricht nach 5 Sekunden ausblenden
            const timer = setTimeout(() => setMessage(null), 5000);
            return () => clearTimeout(timer);
        }
    }, [location.state]);

    return (
        <div>
            <CustomNavbar />
            <div className="container mt-4">
                <h1>Hallo, {firstName}!</h1>

                {/* Erfolgsmeldung */}
                {message && (
                    <div className="alert alert-success">
                        {message}
                    </div>
                )}

                <p>Hier hast du eine Übersicht über diverse Dienstleistungen und Funktionen: </p>
                <div>
                    <HaesManagement />
                    <br/>
                    <br/>
                </div>
            </div>
        </div>
    );
};

export default Service;
